<template>
  <div class="home-page-wrapper searchbusiness-wrapper">
    <Header />
    <BusinessList />
    <Footer />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import BusinessList from "../components/common/BusinessList";
import { toaster } from "../utils/helper";
import ApiCaller from "../utils/apicaller";
import Vue from "vue";
import VueCookie from "vue-cookie";
Vue.use(VueCookie);

export default {
  name: "SearchAllBusinessList",
  components: {
    Header,
    Footer,
    BusinessList,
  },
  props: {},
  data() {
    return {
      limit: 0
    };
  },
   computed: {
    ...mapState(["business"])
  },
  methods: {

  },
  mounted() {
   
  }
};
</script>
<style></style>
